import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppContextMenu from "./components/common/contextMenu";
import router from "./navigation/router";

import "react-toastify/dist/ReactToastify.css";
import "rsuite-color-picker/lib/styles.css";
import "./App.css";
import { ThemeProvider } from "./components/common/ThemeContext";
import "./components/surfsight-ui/www/build/cloud-ui-components.esm";

import { useMsal } from "@azure/msal-react";
import { useEffect, useRef } from "react";
import { APP_CONFIG } from "./constants/constants";
import { useLoginHandler } from "./hooks/loginHandler";
import { localStorageKeys } from "./utils/localStorageItems";

function App() {
  const { consumeAzureTokenForLogin, handleAzureAuthError } = useLoginHandler({
    screen: "loginScreen",
  });

  // MSAL is (await-) initialized in index.tsx and then we use
  // the instance here (and across the react app) to call any MSAL API
  const { instance: msalInstance } = useMsal();

  // mechanism to ensure that MSAL redirect is handled only once
  const msalRedirectHandled = useRef(false);
  useEffect(() => {
    if (msalRedirectHandled.current) return;
    msalRedirectHandled.current = true;
    msalInstance
      .handleRedirectPromise()
      .then((response) => {
        if (!response) return; // defensive condition to prevent redirects to Azure AD

        // Azure login SUCCESS
        const azureIdToken = response.idToken;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const azureAccessToken = response.accessToken;

        const azureAccount = response.account;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const azureAccountEmail = azureAccount.username || azureAccount.name;

        // Store Azure token (not app auth)
        localStorage.setItem(localStorageKeys.azureIdToken, azureIdToken);
        localStorage.setItem(
          localStorageKeys.azureTokenExpiry,
          `${response?.expiresOn?.getTime?.()}`
        );
        if (APP_CONFIG.DEBUG.ALL) console.log("AZURE_RES", response);

        // Exchange with backend
        consumeAzureTokenForLogin(azureIdToken); // 'azureAccountEmail' should not be sent to backend, instead backend should identify user based on the azureIdToken alone. This is because email can be different based on the type of Azure account (personal vs organizational) and can cause issues in user identification and login if sent to backend. --- IGNORE ---
      })
      .catch(handleAzureAuthError);
  }, [msalInstance]);

  return (
    <>
      {/* moved redux <Provider /> to index.tsx to allow use on this component */}
      <ThemeProvider>
        <RouterProvider
          future={{
            v7_startTransition: true,
          }}
          router={router}
        />
        <ToastContainer
          theme="colored"
          bodyClassName={`text-sm`}
          autoClose={3000}
          position="bottom-right"
          style={{ zIndex: 999990 }}
          className="print:hidden"
        />
        {/* 999990 is above primary overlay defined in tailwind.config.js */}
        <AppContextMenu />
      </ThemeProvider>
    </>
  );
}

export default App;
